import axios from 'axios';
import { HTTPGenericResponse } from '../../../../finance/constants/FinanceModels';
import { ServerSideTypes } from '../../common/OperationCommonTypes';
import EquipmentTypes from '../Types';

export { equipmentActions };

function equipmentActions() {
    const baseUrl = ``;

    return {
        createEquipment,
        editEquipment,
        deleteEquipment,
        getAll,
        downloadTemplate,
        downloadExcel,
        uploadEquipment,
        checkCode
    }

    async function createEquipment(tenant:string,payload: EquipmentTypes.IEquipment) {
        return new Promise(function (resolve, reject) {
            axios.post(`${baseUrl}/masterdatavehicle/equipment`, payload,{params:{tenant:tenant}}
            ).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error.response)
            })
        });
    }

    async function editEquipment(tenant:string,payload: EquipmentTypes.IEquipment) {
        return new Promise(function (resolve, reject) {
            axios.put(`${baseUrl}/masterdatavehicle/equipment/${payload.id}`, payload,{params:{tenant:tenant}}
            ).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error.response)
            })
        });
    }

    async function deleteEquipment(tenant:string,id: number) {
        return new Promise(function (resolve, reject) {
            axios.delete(`${baseUrl}/masterdatavehicle/equipment/${id}?tenant=${tenant}`
            ).then(function (response) {
                resolve(response.data);
            }).catch(function (error) {
                reject(error.response)
            })
        });
    }

    async function getAll(tenant:string,payload: EquipmentTypes.IEquipmentFilters) {
        return new Promise(function (resolve, reject) {
            axios.get<ServerSideTypes.IResult<any>>(`${baseUrl}/masterdatavehicle/equipment`, { params: {tenant, ...payload }}
            ).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error.response)
            })
        });
    }

    async function downloadTemplate() {
        return new Promise(function (resolve, reject) {
            axios.get(`${baseUrl}/masterdatavehicle/equipment/template`, {
               
                responseType: 'arraybuffer',
                headers: { 'Access-Control-Allow-Origin': true }
            }
            ).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error)
            })
        });
    }

    async function downloadExcel(tenant:string,payload: EquipmentTypes.IEquipmentFilters) {
        return new Promise(function (resolve, reject) {
            axios.get(`${baseUrl}/masterdatavehicle/equipment/excel`, {
                params: {tenant, ...payload},
                responseType: 'arraybuffer',
                headers: { 'Access-Control-Allow-Origin': true },
                
            }
            ).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error)
            })
        });
    }

    async function uploadEquipment(tenant:string,file: File) {
        let formData = new FormData();
        formData.append("file", file);

        return new Promise(function (resolve, reject) {
            axios.post(`${baseUrl}/masterdatavehicle/equipment/file`, formData, {params:{tenant:tenant}, headers: { "Content-Type": "multipart/form-data" } })
                .then(function (response) {
                    resolve(response);
                }).catch(function (error) {
                    reject(error.response)
                })
        });
    }


    async function checkCode(tenant:string,code: string) {
        return new Promise(function (resolve, reject) {
            axios.get(`${baseUrl}/masterdatavehicle/equipment/code/${code}`,{params:{tenant:tenant}}
            ).then(function (response) {
                resolve(response);
            }).catch(function (error) {
                reject(error)
            })
        });
    }
}